exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bulma .test-statistics-tab {\n  font-size: 18px;\n}\n.bulma .test-statistics-tab .tabs-container .tabs-details {\n  background: #ffffff;\n  border-top: 2px solid #ECECEC;\n  border-radius: 0;\n  padding: 0;\n}\n.bulma .test-statistics-tab .tabs-container .tabs a {\n  font-weight: bold;\n  color: #000000;\n}", ""]);

// exports
